import { Image } from "@chakra-ui/image";

interface SeeOriginalPhotoButtonProps {
  chengeImage: () => void;
  showOriginalPhoto: boolean;
}

export const SeeOriginalPhotoButton = (props: SeeOriginalPhotoButtonProps) => {
  const { chengeImage, showOriginalPhoto } = props;

  const handleSeeOriginalPhoto = () => {
    chengeImage();
  };

  return (
    <Image
      src={process.env.PUBLIC_URL + "/assets/images/Comparing.svg"}
      h={{ base: "42px", md: "52px" }}
      w={{ base: "42px", md: "52px" }}
      onClick={handleSeeOriginalPhoto}
      filter={showOriginalPhoto ? "invert(100%)" : ""}
    />
  );
};
